<template>
  <div class="col-span-12 sm:col-span-6 md:col-span-4">
    <div class="pt-course-serie">
      <nuxt-link :to="`${COURSE_BASE_URL}/${serie.slug}`">
        <div class="pt-course-serie__overlay">
          <div class="pt-course-serie__wrapper">
            <NuxtImg
              v-if="serie.main_image"
              :key="serie.id"
              :alt="serie.main_image.alternativeText ? serie.main_image.alternativeText : ''"
              :title="serie.meta_title"
              :src="serie.main_image.url"
              loading="lazy"
            />
          </div>
          <div v-if="serie.event_features.event_format !== 'online'">
            <Labels
              v-for="(item, index) in listOfSessionsFuture"
              :key="index"
              label-type="white"
              :items="uppercase(dateWithDayAndMonth(item.date))"
              class="absolute top-0 p-4"
            />
          </div>
          <icon
            v-if="serie.icons && serie.icons.pt_icons.length"
            class="absolute top-0 right-0 m-4"
            name="pt-sustainability-wheel"
            type="svg"
          />
        </div>
      </nuxt-link>
      <div>
        <h2 class="p-4">
          <nuxt-link :to="`${COURSE_BASE_URL}/${serie.slug}`">
            {{ serie.meta_title }}
          </nuxt-link>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
import { dateWithDayAndMonth, isSameOrBeforeDate } from '~/utils/helpers/date';
import { uppercase } from '@/utils/helpers/string';
import { COURSE_BASE_URL } from '~/utils/enums';
import Labels from '~/components/Labels';

export default {
  name: 'Serie',
  components: {
    Labels
  },
  props: {
    serie: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dateWithDayAndMonth,
      uppercase,
      COURSE_BASE_URL
    };
  },
  computed: {
    listOfSessionsFuture() {
      return this.serie.list_of_sessions.filter(session => isSameOrBeforeDate(session.date));
    }
  }
};
</script>
<style src="./style.scss" lang="scss" />
